import React from "react";
import Weather from "./Weather";

import "./styles/WeatherApp.css";

export default function WeatherApp() {
  return (
    <div className="WeatherApp">
      <Weather />
    </div>
  );
}
